import { defineStore } from 'pinia'
import { useAsyncResource, UnauthorizedError } from '../composables/useAsyncResource'

// Admin-only, read-only list of recent expert-pool consultations.

export interface ExpertConsultation {
  id: number
  role: string
  repo: string | null
  mode: string
  status: string
  question_excerpt: string
  cost_cents: number | null
  duration_ms: number | null
  memory_written: boolean
  created_at: string
}

export const useExpertConsultationsStore = defineStore('expertConsultations', () => {
  const {
    data: consultations,
    loaded,
    error: loadError,
    refresh: fetchAll,
  } = useAsyncResource<ExpertConsultation[]>(
    async () => {
      const res = await fetch('/api/v1/agent/expert_consultations', { credentials: 'include' })
      if (res.status === 401) throw new UnauthorizedError()
      if (!res.ok) throw new Error(`Failed to load consultations: ${res.status}`)
      const body = (await res.json()) as { consultations: ExpertConsultation[] }
      return body.consultations
    },
    { initialValue: [] },
  )

  return { consultations, loaded, loadError, fetchAll }
})
